export const GET_MEGA_MENU = "GET_MEGA_MENU";
